module.exports = __webpack_public_path__ + "img/ringe.a85de309.jpeg";